var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoThumb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700px",
    height: "500px",
    viewBox: "0 0 700 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "no-thumb@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "no-thumb",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 700,
    height: 500
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.1,
    fill: "#000000",
    x: 0,
    y: 0,
    width: 700,
    height: 500
  }), /*#__PURE__*/React.createElement("g", {
    id: "panorama_FILL0_wght400_GRAD0_opsz48",
    opacity: 0.151638939,
    transform: "translate(244.000000, 165.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.975,170 C11.715,170 7.9875,168.40625 4.7925,165.21875 C1.5975,162.03125 0,158.3125 0,154.0625 L0,15.9375 C0,11.6875 1.5975,7.96875 4.7925,4.78125 C7.9875,1.59375 11.715,0 15.975,0 L197.025,0 C201.285,0 205.0125,1.59375 208.2075,4.78125 C211.4025,7.96875 213,11.6875 213,15.9375 L213,154.0625 C213,158.3125 211.4025,162.03125 208.2075,165.21875 C205.0125,168.40625 201.285,170 197.025,170 L15.975,170 Z M15.975,154.0625 L197.025,154.0625 L197.025,15.9375 L15.975,15.9375 L15.975,154.0625 Z M41.80125,127.5 L171.465,127.5 L132.32625,74.640625 L97.4475,120.859375 L72.9525,86.59375 L41.80125,127.5 Z M15.975,154.0625 L15.975,15.9375 L15.975,154.0625 Z",
    id: "Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoThumb);
export default __webpack_public_path__ + "static/media/no-thumb.9112a35a9865e38af6fb71424ddad28f.svg";
export { ForwardRef as ReactComponent };